import type { RouteObject } from "react-router-dom";
import { SharedArtifactPage } from "./pages/shared-artifact";

export const sharingRoutes: RouteObject[] = [
	{
		path: "/share/:token",
		element: <SharedArtifactPage />,
	},
];
